<div class="card custom-card my-1 border-0">
  <div class="card-body mb-1">
    <div class="row mb-3">
      <div class="col-6">
        <label class="col-form-label col-auto">
          <i class="bi bi-search me-2"></i>
          ค้นหาข้อมูล
        </label>
      </div>
    </div>
    <hr>
    <div class="row mb-1 ps-4 pe-4">
      <div class="col-xl-6 col-sm-12 mt-3">
          <label class="form-label">
            วันที่ประเมิน
          </label>
        <gt-ng-datepicker id="startDate" name="startDate" [(ngModel)]="params.startDate"> </gt-ng-datepicker>
      </div>
      <div class="col-xl-6 col-sm-12 mt-3">
          <label class="form-label">
            ถึงวันที่
          </label>
        <gt-ng-datepicker id="endDate" name="endDate" [(ngModel)]="params.endDate"> </gt-ng-datepicker>
      </div>
    </div>
    <div class="row mb-1 ps-4 pe-4">
      <div class="col-xl-6 col-sm-12 mt-3">
          <label class="form-label">
            ชื่อสถานประกอบการ
          </label>
        <app-manufacturer-autocomplete type="text" name="maunufacturer" [(ngModel)]="manufacturerSelected"></app-manufacturer-autocomplete>
      </div>
      <div class="col-xl-6 col-sm-12 mt-3">
          <label class="form-label">
            ระดับความพึงพอใจ
          </label>
          <select class="form-select" [(ngModel)]="params.rate">
            <option [ngValue]="null" selected>---เลือกทั้งหมด---</option>
            <option [ngValue]="1">น้อยที่สุด</option>
            <option [ngValue]="2">น้อย</option>
            <option [ngValue]="3">ปานกลาง</option>
            <option [ngValue]="4">มาก</option>
            <option [ngValue]="5">มากที่สุด</option>
          </select>
      </div>
    </div>
    <div class="row mb-3 mt-5">
      <div class="col-12 text-start">
        <div class="text-center">
          <button type="button"
                  class="btn btn-custom btn-custom-theme me-2" (click)="search()">
            <i class="bi bi-search me-2"></i>
            ค้นหา
          </button>
          <button type="button"
                  class="btn btn-custom btn-light me-2" (click)="clear()">
            <i class="bi bi-arrow-clockwise me-2"></i>
            ล้างข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card custom-card my-3 border-0">
  <div class="card-body mb-3">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
      <div class="mb-2 mb-md-0">
    <span>
      รายการทั้งหมด {{ pageData?.totalElements | number }} รายการ
    </span>
      </div>
      <div class="d-flex flex-column flex-sm-row">
        <button class="btn btn-custom btn-danger mb-2 mb-sm-0 me-sm-2" (click)="export('pdf')">
          <i class="bi bi-file-pdf me-1"></i>
          ส่งออกไฟล์ Pdf
        </button>
        <button class="btn btn-custom btn-custom-theme" (click)="export('xlsx')">
          <i class="bi bi-file-excel me-1"></i>
          ส่งออกไฟล์ Excel
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th nowrap scope="col" class="">ลำดับ</th>
          <th nowrap scope="col" class="">วันที่ประเมิน</th>
          <th nowrap scope="col" class="">ชื่อสถานประกอบการ</th>
          <th nowrap scope="col" class="">ชื่อ-นามสกุล</th>
          <th nowrap scope="col" class="">Email / อีเมล</th>
          <th nowrap scope="col" class="">ระดับความพึงพอใจ</th>
          <th nowrap scope="col" class="">ความเห็น</th>
        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr *ngIf="isLoading">
          <td class="text-muted text-center" colspan="7">
            <app-async-loading></app-async-loading>
          </td>
        </tr>
        <tr *ngIf="!isLoading && !pageData?.content?.length">
          <td class="text-muted text-center" colspan="7">
            <app-not-found></app-not-found>
          </td>
        </tr>
        <tr *ngFor="let item of pageData?.content; let i= index">
          <td class="text-center">{{(pageData.number*pageData.size)+i+1}}</td>
          <td class="text-center">{{item.createdDate | thaidatetime:  {showtime:false} }}</td>
          <td class="text-center">{{item?.user?.manufacturer?.businessName}}</td>
          <td class="text-center">{{item?.user?.fullName}}</td>
          <td class="text-center">{{item?.user?.email}}</td>
          <td class="text-center">{{item?.rate}}</td>
          <td class="text-center">{{item?.comment}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageData?.number + 1"
                    (pageChange)="search($event)"
                    [pageSize]="pageData?.size"
                    [collectionSize]="pageData?.totalElements"></ngb-pagination>
  </div>
</div>
